<template>
  <div>
    <div class="my-3">
      <span>Comentários</span>
    </div>
    <v-textarea
      append-icon="mdi-comment-alert"
      :readonly="false /*disabled*/"
      auto-grow
      rows="1"
      class="mb-2"
      outlined
      persistent-hint
      filled
      @change="changeCommentInIDB"
      v-model="oneExecution.done_items[question].comment"
      label="Descreva o ocorrido"
      :rules="[
        ruleRequired('Campo obrigatório!'),
        ruleMinLen(6, 'caracteres'),
        ruleMaxLen(500, 'caracteres')
      ]"
      color="secondary"
    />

    <div class="mt-2" v-if="oneExecution.done_items[question].comment_audio">
      <div class="text--darken-1">Comentário em áudio: </div>
      <audio-player :media_url="oneExecution.done_items[question].comment_audio"></audio-player>
    </div>
    <!-- <v-text-field v-model="oneExecution.done_items[question].comment" prepend-icon="mdi-search" label="O que houve?"></v-text-field> -->
  </div>
</template>

<script>
import validations from "@/mixins/validations";
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'CommentFail',
  components: {
    AudioPlayer: () => import('@/components/forms/show/done_form/done_item/AudioPlayer.vue')
  },
  mixins: [validations],
  data() {
    return {
      key: null
    }
  },
  methods: {
    changeCommentInIDB() {
      // ! REPETIR PARA TODOS OS ITEMS
      this.oneExecution.done_items[this.question].answer_changed = true
      this.updateDoneItemOnlyIdb(this.oneExecution.done_items[this.question])
    },
    ...mapActions({
      updateDoneItemOnlyIdb: 'Execution/updateDoneItemOnlyIdb',
    })
  },
  created () {
    // console.log('comment ', this.oneExecution.done_items[this.question].comment);
    if (this.oneExecution.done_items[this.question].comment){
      this.oneExecution.done_items[this.question].had_comment = true
    }
  },
  computed: {
    name() {
      return null 
    },
    ...mapState({
      question: state => state.Execution.question,
      oneExecution: state => state.Execution.oneExecution,
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>
